import MediaQuery, { useMediaQuery } from "react-responsive"
import React from "react"

export enum SCREEN {
  TABLET = 767,
  TABLET_MAX = 1023,
  DESKTOP = 1024,
  DESKTOP_BIG = 1200,
  DESKTOP_BIGGER = 1380,
}

type BreakpointProps = {
  limit?: boolean
}

export const TabletBreakpoint = (props: React.PropsWithChildren<BreakpointProps>) => (
  <MediaQuery minWidth={SCREEN.TABLET} maxWidth={props.limit ? SCREEN.TABLET_MAX : undefined}>
    {props.children}
  </MediaQuery>
)
export const DesktopBreakpoint = (props: React.PropsWithChildren<BreakpointProps>) => (
  <MediaQuery minWidth={SCREEN.DESKTOP}>{props.children}</MediaQuery>
)
export const BigDesktopBreakpoint = (props: React.PropsWithChildren<BreakpointProps>) => (
  <MediaQuery minWidth={SCREEN.DESKTOP_BIG}>{props.children}</MediaQuery>
)

export const useDesktopBreakpoint = () => useMediaQuery({ minWidth: SCREEN.DESKTOP })
